import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import createStore from "./creatStore";
import { auth } from "./config";
import { getUser } from "./actions";
import { saveState } from "./utils/localstorage";
import { throttle } from "lodash";

const store = createStore();

auth.onAuthStateChanged(user => {
  if (user) {
    store.dispatch(getUser(user));
  } else {
    auth.signOut();
    store.dispatch(getUser(null));
  }
});

store.subscribe(function() {
  //console.log(store.getState());
  const currentState = store.getState();
  //console.log(currentState);
  // saveState calls JSON.stringify which is rather expensive
  // to be called repeatedly on every state change
  // using throttle saveState will not be called
  // more than specified milliseconds
  const MAX_CALL_IN_MILLISECONDS = 1000;

  const persistState = saveState({
    user: currentState.user,
    loading: currentState.loading,
    vacancies: currentState.vacancies,
    selectedApplicants: currentState.selectedApplicants
  });

  throttle(() => saveState(persistState), MAX_CALL_IN_MILLISECONDS);
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js